import './App.css';
import {Routes, Route} from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./components/Routing/ProtectedRoute";
import ForgotPW from "./pages/ForgotPW/ForgotPW";
import PWReset from "./pages/PWReset/PWReset";
import NewPassword from "./pages/NewPassword/NewPassword";
import Users from "./pages/Users/Users";
import Categories from "./pages/Category/Categories/Categories";
import CategoryEdit from "./pages/Category/CategoryEdit/CategoryEdit";
import AddCategory from "./pages/Category/AddCategory/AddCategory";
import AddVideo from "./pages/Home/AddVideo/AddVideo";
import VideoEdit from "./pages/Home/VideoEdit/VideoEdit";

const App = () => {
    return (
        <Routes>
            <Route path="/bejelentkezes" element={<Login/>}/>
            <Route path="/elfelejtett-jelszo" element={<ForgotPW/>}/>
            <Route path="/jelszo-visszaallitas" element={<PWReset/>}/>
            <Route path="/" element={<ProtectedRoute/>}>
                <Route path="/" element={<Home/>}/>
                <Route path="/uj-jelszo" element={<NewPassword/>}/>
                <Route path="/felhasznalok" element={<Users/>}/>
                <Route path="/kategoriak" element={<Categories/>}/>
                <Route path="/kategoriak/uj-hozzaadasa" element={<AddCategory/>}/>
                <Route path="/kategoriak/szerkesztes/:id" element={<CategoryEdit/>}/>
                <Route path="/videok/uj-hozzaadasa" element={<AddVideo/>}/>
                <Route path="/videok/szerkesztes/:id" element={<VideoEdit/>}/>
            </Route>
        </Routes>
    );
}

export default App;
